/**
 * Utility for managing saved GitHub URLs in localStorage
 */

const STORAGE_KEY = 'github_urls_history';
const MAX_URLS = 10;

/**
 * Get all saved GitHub URLs
 * @returns {Array<string>}
 */
export const getSavedUrls = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch (error) {
    console.error('Error reading saved URLs:', error);
    return [];
  }
};

/**
 * Save a GitHub URL to history (only if not already saved)
 * @param {string} url - GitHub URL to save
 */
export const saveUrl = (url) => {
  try {
    if (!url || url.trim() === '') return;

    const saved = getSavedUrls();
    
    // Remove if already exists (to move to top)
    const filtered = saved.filter(u => u !== url);
    
    // Add to beginning
    const updated = [url, ...filtered].slice(0, MAX_URLS);
    
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (error) {
    console.error('Error saving URL:', error);
  }
};

/**
 * Remove a URL from history
 * @param {string} url - GitHub URL to remove
 */
export const removeUrl = (url) => {
  try {
    const saved = getSavedUrls();
    const updated = saved.filter(u => u !== url);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (error) {
    console.error('Error removing URL:', error);
  }
};

/**
 * Clear all saved URLs
 */
export const clearAllUrls = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing URLs:', error);
  }
};
